
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSimplifiedSimplifiedBuoyIsolatedDanger as ObiSimplifiedSimplifiedBuoyIsolatedDangerElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-simplified-simplified-buoy-isolated-danger.js';
 
 
 

 
 export const ObiSimplifiedSimplifiedBuoyIsolatedDanger = createComponent({
   react: React,
   tagName: 'obi-simplified-simplified-buoy-isolated-danger',
   elementClass: ObiSimplifiedSimplifiedBuoyIsolatedDangerElement,
   events: {
     
   }
  });
 
 